import { useSubscribe } from './useSubscribe';

export default function NewsletterBar() {
  const { email, setEmail, status, submit } = useSubscribe();

  return (
    <section className="bg-brand text-charcoal">
      <div className="site-container grid items-center gap-6 py-8 md:grid-cols-[1fr_1.2fr] md:gap-12">
        <div>
          <h2 className="text-inherit font-display text-2xl font-bold normal-case leading-tight tracking-normal">Recevez nos actualités directement dans votre boîte mail</h2>
          <p className="mt-2 text-[0.9375rem] leading-relaxed text-charcoal">Inscrivez-vous pour suivre nos projets, nos innovations et nos bonnes pratiques de construction.</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" noValidate={false}>
          <label className="sr-only" htmlFor="newsletter-email">Adresse e-mail</label>
          <input
            id="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre adresse e-mail"
            className="h-12 flex-1 rounded-[2px] border border-transparent bg-white px-4 text-base text-black placeholder:text-ink/70 focus:border-charcoal focus:outline-none"
          />
          <button type="submit" disabled={status === 'loading'} className="h-12 rounded-[2px] border border-charcoal px-8 text-[0.875rem] font-semibold uppercase tracking-[0.094rem] transition-colors duration-300 hover:bg-charcoal hover:text-white disabled:opacity-60">
            {status === 'loading' ? 'Envoi…' : 'S’abonner'}
          </button>
        </form>
        <div role="status" aria-live="polite" className="md:col-start-2">
          {status === 'ok' && <span className="text-sm font-medium text-charcoal">Merci, votre inscription est bien enregistrée.</span>}
          {status === 'error' && <span className="text-sm font-medium text-charcoal">Une erreur est survenue. Veuillez réessayer.</span>}
        </div>
      </div>
    </section>
  );
}
